module.exports = __webpack_public_path__ + "img/jmstd02.898164cf.png";